import { LocationHome } from './location-home';
import { StorageTip } from './storageTip';
import { Faq } from './faq';
import { About } from "./about";
import { Home } from "./home";
import { ReserveAUnit } from "./reserveAUnit";
import { SizeClimateControlledInfo } from "./sizeClimateControlledInfo";
import { UnitSizes } from "./unitSizes";
import { Login } from "./login";
import { Portal } from './portal';
import { Contact } from './contact';
import { GeneralInfoSection } from './generalInfoSection';

export class PageSettings {
  title: string;
  about: About;
  home: Home;
  locationHome: LocationHome = new LocationHome();
  login: Login;
  portal: Portal;
  contact: Contact;
  viewUnits: {
    leftSide?: {
      cardInnerHtml?: string,
      title?: string
    },
    rightSide?: {
      cardInnerHtml?: string,
      title?: string
    }
  };
  reserveAUnit: ReserveAUnit;
  sizeGuide: {
    title: string,
    body: string,
    hideButtons: boolean;
    sizeClimateControlledInfo: SizeClimateControlledInfo,
    sizes?: UnitSizes[]
  };
  privacyPolicy?: {
    body?: string,
    showPrivacyPolicy: boolean
  };
  rentAUnit: {
    showAlternateContact: boolean;
    showCompanyName: boolean;
    showCompanyPhone: boolean;
    showDateOfBirth: boolean;
    alternateContactOptional?: boolean;
    alternateContactBlurb?: string;
    emergencyContactInstead?: boolean;
    hideToggles?: boolean;
    hideMilitaryToggle?: boolean;
    hideLicenseInfo?: boolean;
    licenseOptional?: boolean;
    daysARentalCanBeMadeInAdvance?: number;
    useDatePicker?: false;
    forceAutoPay?: boolean;
    openTechPhoneTypes?: boolean;
    militarySelectedBlurb?: string;
    useRentUnitBlurb?: boolean;
    rentUnitBlurb?: string;
    requireSsn?: boolean;
    showUnavailableUnits?: boolean;
  };
  gateCodeMinLength: number;
  gateCodeMaxLength: number;
  useGateCodeMaxValue: boolean;
  gateCodeMaxValue?: number;
  useGateCodeMinValue: boolean;
  gateCodeMinValue?: number;

  portableQuote?: {
    showImages?: boolean;
    showSliderArrows?: boolean;
    sliderAutoPlay?: boolean;
    sliderUrls?: string[];
    imagesBlurb?: string;
    htmlRowHtml?: string;
    showHtmlRow?: boolean;
  };

  reviews?: {
    pageTitle?: string;
    reviewLinkUrl?: string;
    metaTitle?: string;
    metaImage?: string;
    metaImageAlt?: string;
    metaDescription?: string;
  };

  faqs?: {
    leftColumn?: Faq[];
    rightColumn?: Faq[];
    blurb?: string;
    blurbTitle?: string;
  };

  storageTips?: {
    leftColumn: StorageTip[];
    rightColumn: StorageTip[];
    blurb?: string;
    blurbTitle?: string;
  };

  generalInfo?: {
    sections?: GeneralInfoSection[];
  };

  storageCalculator?: {
    blurb?: string;
  };

  selectLocation?: {
    blurb?: string;
  };

  blogListingPageMetaData?: {
    metaTitle?: string;
    metaImage?: string;
    metaImageAlt?: string;
    metaDescription?: string;
  }

  moveOutNoLogin?: {
    title: string;
    blurb: string;
  }

  constructor(title = 'Just Another StoragePug Website') {
    this.title = title;
    this.about = new About();
    this.home = new Home();
    this.login = new Login();
    this.portal = new Portal();
    this.contact = new Contact();
    this.reserveAUnit = new ReserveAUnit();
    this.rentAUnit = {
      showAlternateContact: true,
      showCompanyName: false,
      showCompanyPhone: false,
      showDateOfBirth: false,
      alternateContactOptional: true,
      licenseOptional: false,
      requireSsn: false
    };
    this.gateCodeMinLength = 4;
    this.gateCodeMaxLength = 10;
    this.useGateCodeMaxValue = false;
    this.sizeGuide = {
      title: 'What Size Do I Need?',
      hideButtons: false,
      body: 'Let us help you select the right unit for all your storage needs! <br>' +
        'Our Size Guide will help you easily determine the perfect size. <br>' +
        'Don’t hesitate to contact our storage professionals <br>' +
        'to answer any of your storage questions along the way.',
      sizeClimateControlledInfo: {
        imgUrl: "https://firebasestorage.googleapis.com/v0/b/storpug-604b6.appspot.com/o/snowflake.svg?alt=media&token=41460e3b-a4a4-4dcf-9e23-ae9397fe47c0",
        title: "Available in Climate Controlled",
        body: "Climate Controlled units are inside an Air Conditioned building. They are perfect for your valuables."
      }
    };

    this.storageCalculator = { blurb: null };
    this.selectLocation = { blurb: null };

    this.privacyPolicy = { showPrivacyPolicy: true, body: "<p><strong style=\"background-color: transparent; color: rgb(0, 60, 119);\">Privacy Policy</strong></p><p><span style=\"background-color: transparent; color: rgb(126, 126, 126);\">We respect and are committed to protecting your privacy. We may collect personally identifiable information when you visit our site. We also automatically receive and record information on our server logs from your browser including your IP address, cookie information and the page(s) you visited. We will not sell your personally identifiable information to anyone.</span></p><p><strong style=\"background-color: transparent; color: rgb(0, 60, 119);\">Security Policy</strong></p><p><span style=\"background-color: transparent; color: rgb(126, 126, 126);\">Your payment and personal information is always safe. Our Secure Sockets Layer (SSL) software is the industry standard and among the best software available today for secure commerce transactions. It encrypts all of your personal information, including credit card number, name, and address, so that it cannot be read over the internet.</span></p><p><strong style=\"background-color: transparent; color: rgb(31, 78, 121);\">Refund Policy</strong></p><p><span style=\"background-color: transparent; color: rgb(126, 126, 126);\">All payments are final and no refunds will be processed.</span></p><p><strong style=\"background-color: transparent; color: rgb(31, 78, 121);\">Shipping Policy (if applicable)</strong></p><p><span style=\"background-color: transparent; color: rgb(126, 126, 126);\">All items will ship within 2 business day of the order being placed.</span></p>" };

    this.storageTips = {
      leftColumn: [
        {
          "body": "If you are going to use some of the items on a regular basis, be sure to place them in the front of the unit, making access to them easier.",
          "title": "Frequently Accessing Your Unit"
        },
        {
          "body": "Use wardrobe boxes to hang clothing, draperies and other fabrics so that they can breathe while in storage.",
          "title": "Storing Clothes"
        },
        {
          "body": "When placing your items into storage, draw a simple map of where everything is located. Keep the map along with your lease so it will be handy when you need it.",
          "title": "Keep Your Storage Unit Organized"
        },
        {
          "body": "Label everything you store in your unit and keep a written inventory along with your locator map.",
          "title": "Label Your Stored Items"
        },
        {
          "body": "If you are storing boxes of records or documents, consider using shelves to maximize your self storage space.",
          "title": "Storing Important Documents"
        },
        {
          "body": "Plan to cover your belongings once in storage for further protection.",
          "title": "Protecting Your Stored Belongings"
        }
      ],
      rightColumn: [
        {
          "body": "If storing tables, when possible remove the legs so that you can stand the tabletop vertically.",
          "title": "Storing Tables"
        },
        {
          "body": "Store sofas, couches, and tables on their ends (not recommended for sofa beds, however). Place an old sheet or plastic on the floor underneath the sofa to further protect the fabric.",
          "title": "Furniture with Legs"
        },
        {
          "body": "If storing a dresser or chest of drawers, use the drawers as additional storage space. Pack lightweight items into the drawers to maximize the storage space and minimize the area you need.",
          "title": "Furniture with Drawers"
        },
        {
          "body": "When placing your boxes into self storage, place the heavier boxes on the bottom with each box stacked on top getting progressively lighter in weight.",
          "title": "Storing Boxes"
        },
        {
          "body": "Remove or fold the handles on lawnmowers and other garden equipment. It is important that you drain all gasoline out of a tool before storing it!",
          "title": "Storing Items with Handles"
        }
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/pageSettings.ts